import React from 'react';

const MobileCard = ({ data, onViewProfile, onSponsor }) => {
  const year = data.date_of_birth ? new Date(data.date_of_birth).getFullYear() : '';
  const address = data.address ? data.address.slice(-10) : '';

  // Helper: get all categories as array
  let categoryList = [];
  if (Array.isArray(data.categories) && data.categories.length > 0) {
    categoryList = data.categories.map(cat => cat.category_name || cat.name || cat);
  } else if (data.category_name) {
    categoryList = [data.category_name];
  }

  // Calculate age (current year - birth year)
  let age = '';
  if (data.date_of_birth) {
    const birthYear = new Date(data.date_of_birth).getFullYear();
    const currentYear = new Date().getFullYear();
    age = `${currentYear - birthYear}Y`;
  }

  // Truncate name to max 10 characters, add dot if longer
  const displayName = data.name && data.name.length > 10 ? data.name.slice(0, 10) + '.' : data.name;

  const getCategoryBackgroundColor = (categoryName) => {
    if (!categoryName) return "#D3B1FF";
    const category = categoryName.toLowerCase();
    if (category === 'hafiz') return '#a4b465';
    if (category === 'communal violence') return '#fca470';
    if (category === 'orphans') return '#94b088';
    if (category === 'mob lynching') return '#e27878';
    if (category === 'police atrocity') return '#F6EFBD';
    if (category === 'impoverish') return '#bd90a9';
    if (category === 'demolition') return '#96b1ab';
    if (category === 'refugees') return '#bda887';
    if (category === 'disaster') return '#ABE0F0';
    return '#bda887';
  };

  const bgColor = getCategoryBackgroundColor(categoryList[0]);

  return (
    <div
      style={{
        background: bgColor,
        borderRadius: '16px',
        boxShadow: '0 3px 10px rgba(0,0,0,0.07)',
        padding: 0,
        width: '160px',
        minHeight: '320px',
        height: '320px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        justifyContent: 'flex-end',
        overflow: 'hidden',
        
      }}
      className="mobile-kid-card"
    >
      {/* Image area */}
      <div
        style={{
          width: '100%',
          height: '160px',
          background: data.avatar_url ? 'none' : '#e6f5e6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      >
        {data.avatar_url && (
          <img
            src={data.avatar_url}
            alt={data.name}
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 0 }}
          />
        )}
      </div>

      {/* Card content */}
      <div
        style={{
          width: '100%',
          padding: '0 0.8rem 0.8rem 0.8rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-end',
          marginTop: '160px',
          height: '160px',
        }}
      >
        {/* Name */}
        <div
          style={{
            fontWeight: 600,
            fontSize: '16px',
            color: '#293E4F',
            marginTop: '12px',
            marginBottom: 0,
            textAlign: 'left',
            width: '100%',
            lineHeight: 1.1,
          }}
        >
          {displayName}
          &nbsp;
          <span style={{fontSize: '10px', color: '#293E4F', fontWeight: '300'}}>
            {age && <span>{age}</span>}
            {age && data.state && <span style={{ margin: '0 2px', fontSize: 8 }}>, </span>}
            {data.state && <span>{data.state}</span>}
          </span>
        </div>

        {/* Category badge */}
        <div
          style={{
            background: "rgba(255, 255, 255, 0.3)",
            color: "#333",
            fontSize: 10,
            fontWeight: 600,
            fontFamily: "Inter",
            borderRadius: 12,
            padding: "2px 8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "fit-content",
            margin: "4px auto 6px auto",
            minHeight: 16,
            boxSizing: "border-box",
            letterSpacing: 0.2,
          }}
        >
          {categoryList[0]}
        </div>

        {/* Monthly Expenses */}
        <p style={{
          color: '#293E4F',
          fontSize: '10px',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'center',
          margin: '4px auto 6px auto'
        }}>
          Monthly Expenses: ₹{data.total_expenses}
        </p>

        {/* Sponsor button */}
        <button
          style={{
            background: '#251134',
            border: 'none',
            borderRadius: '12px',
            padding: '2px 2px',
            color: '#fdc512',
            fontWeight: 500,
            fontSize: '14px',
            width: '100%',
            marginTop: '4px',
            marginBottom: '6px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
            cursor: 'pointer',
            transition: 'background 0.2s',
          }}
          onClick={() => onSponsor(data.id)}
        >
          Sponsor
        </button>

        {/* View Profile Link */}
        <a 
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            textDecoration: "underline",
            fontSize: "10px",
            fontWeight: "400",
            color: "#293E4F",
            cursor: "pointer",
          }}
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onViewProfile(data.id);
          }}
        >
          View Profile
        </a>
      </div>
    </div>
  );
};

export default MobileCard; 